// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import SettingsComponent from '../components/Settings'

const SettingsRoute: FC<RouteComponentProps> = props => <SettingsComponent {...props} />

export default WithContainerRoute(SettingsRoute)
